import { NavigationEnd, Router } from '@angular/router';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, of, Subject, switchMap } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DrawerOptions } from '../interfaces/drawer-options';
import { ReturnDrawerData } from '../interfaces/return-drawer-data';

@Injectable()
export abstract class DrawersService implements OnDestroy {
  private readonly router: Router = inject(Router);

  abstract create$(drawerData: DrawerOptions<any>): Observable<ReturnDrawerData>;
  abstract closeDrawer$(options?: { isOpenedFromDrawer: boolean }): Observable<void>;

  protected readonly destroy$: Subject<void> = new Subject<void>();

  constructor() {
    this.observeNavigation();
  }

  private observeNavigation(): void {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        switchMap(() => {
          const closeDrawer$ = this.closeDrawer$();
          if (!closeDrawer$) {
            return of(undefined);
          }
          return closeDrawer$;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
